import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import FlyingElements from '../FlyingElements';

const Section = ({ 
  children, 
  variant, // 'light' or 'dark' - if not provided, uses theme
  className = '',
  id,
  withFlyingElements = false,
  ...props 
}) => {
  const { theme } = useTheme();
  const effectiveVariant = variant || theme;
  
  const variants = {
    light: 'bg-afsc-offwhite text-afsc-charcoal',
    dark: 'bg-afsc-slate text-white',
  };

  return (
    <section
      id={id}
      className={`py-20 md:py-32 ${variants[effectiveVariant]} ${className} relative overflow-hidden`}
      {...props}
    >
      {/* Center gradient overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: effectiveVariant === 'dark' 
            ? 'radial-gradient(ellipse at center, rgba(203, 163, 90, 0.15) 0%, transparent 70%)'
            : 'radial-gradient(ellipse at center, rgba(203, 163, 90, 0.12) 0%, transparent 70%)',
        }}
      />
      {withFlyingElements && <FlyingElements count="few" />}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl relative z-10">
        {children}
      </div>
    </section>
  );
};

export default Section;

